import styles from './demoEnv.module.scss';

const DemoEnv: React.FC = () => {
  return <div className={styles.root}>Entorno de pruebas</div>;
};

export default DemoEnv;
